export interface AppEnvironment {
  production: boolean;
  apiUrl: string;
  apiFileUrl: string;
  socketUrl: string;
  ssoLoginUrl: string;
  appVersion: string;
  enableEmailLogin: boolean;
  // v1.2 decision 6 — dev-only "เปิดรอบเบิกจ่าย (ทดสอบ)" trigger on ข้อมูลเอกสารส่งเบิก.
  // True only in dev/local env files, never a secret (mirrors enableEmailLogin).
  enableDisbursementTestTrigger: boolean;
  // Release 1.1 ships from the release-2 branch with these areas frontend-hidden
  // (menus, routes, default landings). Backend endpoints stay live.
  enableDisbursement: boolean;
  enableOverloadMemo: boolean;
  enableCompensationSummary: boolean;
  enableErpLeaveImport: boolean;
}

declare global {
  interface Window {
    __env?: Partial<AppEnvironment>;
  }
}

const runtimeEnv = typeof window === "undefined" ? {} : window.__env ?? {};
const defaultApiUrl = "http://localhost:3000/api";

const withDefault = (value: string | undefined, fallback: string): string =>
  value == null || value === "" ? fallback : value;

const apiUrl = withDefault(runtimeEnv.apiUrl, defaultApiUrl);
const apiFileUrl = withDefault(runtimeEnv.apiFileUrl, apiUrl.replace(/\/api\/?$/, ""));

export const environment: AppEnvironment = {
  production: runtimeEnv.production ?? false,
  apiUrl,
  apiFileUrl,
  socketUrl: withDefault(runtimeEnv.socketUrl, apiFileUrl),
  ssoLoginUrl: withDefault(runtimeEnv.ssoLoginUrl, `${apiUrl.replace(/\/$/, "")}/session/sso/login`),
  appVersion: withDefault(runtimeEnv.appVersion, "v1.0.0"),
  enableEmailLogin: runtimeEnv.enableEmailLogin ?? false,
  enableDisbursementTestTrigger: runtimeEnv.enableDisbursementTestTrigger ?? false,
  enableDisbursement: runtimeEnv.enableDisbursement ?? false,
  enableOverloadMemo: runtimeEnv.enableOverloadMemo ?? false,
  enableCompensationSummary: runtimeEnv.enableCompensationSummary ?? false,
  enableErpLeaveImport: runtimeEnv.enableErpLeaveImport ?? false,
};
